import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section className="bg-brand-alt px-4 py-20" data-id="element-91" data-mp="4vs1604r2hrx">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-92" data-mp="9umiexn2jy9x">
        <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full bg-brand-ocean/10" data-id="element-93" data-mp="9t1mb3l3w79y">
          <ShieldCheckIcon className="h-8 w-8 text-brand-ocean" aria-hidden="true" data-id="element-94" data-mp="ercxpir1upua" />
        </div>
        <h2 className="text-2xl font-extrabold tracking-tight text-brand-deep md:text-3xl" data-id="element-95" data-mp="jqg1kzvamq0o">
          Garanzia soddisfatti o rimborsati
        </h2>
        <p className="mt-5 leading-relaxed text-brand-gray" data-id="element-96" data-mp="skkq3cmyfpd1">
          Se dopo l&apos;acquisto ti accorgi che GEOGRAFIA PRONTA™ non fa per te, richiedi il rimborso entro 30
          giorni: rimborsiamo l&apos;importo completo. Niente domande, niente complicazioni.
        </p>
        <p className="mt-6 inline-flex items-center gap-2 rounded-full border border-brand-sand bg-brand-main px-4 py-2 text-xs font-extrabold tracking-wide text-brand-deep" data-id="element-97" data-mp="17hv9d85u9zjb">
          <ShieldCheckIcon className="h-4 w-4 text-brand-amber" aria-hidden="true" data-id="element-98" data-mp="25pki5klzj99s" />
          Protezione dell&apos;acquirente 30 giorni
        </p>
      </Reveal>
    </section>;
}